import { render, staticRenderFns } from "./addLeaderboard.vue?vue&type=template&id=6a4ca719&lang=pug"
import script from "./addLeaderboard.vue?vue&type=script&lang=js"
export * from "./addLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports